<template>
  <div class="training-intents">
    <template v-if="$store.getters.getPackage == 'premium'">
      <div class="container-fluid">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="title">Unanswered Questions</h3>
          </div>
          <br>
          <br>
          <div class="container-fluid">
            <div
              style="background: white;border-radius: 10px; border: 1px solid #eee;padding: 15px;margin-top: 10px;"
            >
              <div class="row">
                <div class="col-sm-12">
                  <span class="dashboard_datepicker">From:
                    <datepicker
                      v-model="selectedDate.start"
                      style="margin-bottom: 10px;"
                      @selected="onSelectedStartDate"
                    ></datepicker>
                  </span>
                  <span class="hidden-xs" style="margin: 0 10px">-</span>
                  <span class="dashboard_datepicker" style="margin-bottom: 10px;">To:
                    <datepicker v-model="selectedDate.end" style @selected="onSelectedEndDate"></datepicker>
                  </span>
                  <span class="hidden-xs" style="margin-right: 10px;"></span>
                  <div class="hidden-sm hidden-md hidden-lg"></div>
                  <a
                    href="javascript:void(0)"
                    class="btn btn-sm"
                    :class="{'btn-primary': currentFilter == 'today' , 'btn-default' : currentFilter != 'today' }"
                    style="margin-bottom: 5px;"
                    @click="changeDate('today')"
                  >Today</a>
                  <a
                    href="javascript:void(0)"
                    class="btn btn-sm"
                    :class="{'btn-primary': currentFilter == 'this_month' , 'btn-default' : currentFilter != 'this_month' }"
                    style="margin-bottom: 5px;"
                    @click="changeDate('this_month')"
                  >This Month</a>
                  <a
                    href="javascript:void(0)"
                    class="btn btn-sm"
                    :class="{'btn-primary': currentFilter == 'last_month' , 'btn-default' : currentFilter != 'last_month' }"
                    style="margin-bottom: 5px;"
                    @click="changeDate('last_month')"
                  >Last 30 Days</a>
                  <a
                    href="javascript:void(0)"
                    class="btn btn-sm"
                    :class="{'btn-primary': currentFilter == 'this_year' , 'btn-default' : currentFilter != 'this_year' }"
                    style="margin-bottom: 5px;"
                    @click="changeDate('this_year')"
                  >This Year</a>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="col-sm-6">
            <input type="text" class="form-control" placeholder="Search" v-model="search">
          </div>
        </div>
        <div class="row">
          <hr>
        </div>
      </div>

      <template v-if="filterDefaultIntents.length > 0">
        <div>
          <div class="container-fluid">
            <div style="background: #eee;padding: 15px;margin-bottom: 15px;">
              <div class="row" style=" ">
                <div class="col-sm-5">
                  <input type="checkbox" name id v-model="allSelected"> Select All
                </div>
                <div class="col-sm-7" style=" text-align: right">
                  <a
                    href="javascript:void(0)"
                    class="btn btn-primary transparent btn-sm"
                    @click="ignoreAll"
                  >Ignore Selected</a>
                  <!-- <a
                  href="javascript:void(0)"
                  class="btn btn-primary transparent btn-sm"
                  @click="onAddExistingAll"
                  >Add Selected to existing</a>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="container-fluid">
        <div class="row">
          <div class="col-xs-12">
            <template v-if="filterDefaultIntents.length > 0">
              <div class="container-fluid">
                <training-item
                  style="border: 1px solid #eee; padding: 15px; border-left: 3px solid #eee"
                  v-for="(intent, index) in filterDefaultIntents"
                  :key="'intent_' + intent.id + '_'+ index"
                  v-model="filterDefaultIntents[index]"
                  @onAddExistingConversation="currentDefaultIntents = intent;showModal = true"
                  @onSaveTrainingConversation="saveTrainingIntent"
                  :excludedIntentName="excludedIntentName"
                  @onIgnore="onIgnore(intent.id)"
                ></training-item>
              </div>
            </template>
            <template v-else>
              <div class="text-center" style="margin: 35px 0">
                <img src="/static/img/assets/setting/conversation.png" alt style="width: 230px">
                <h3>No conversation</h3>
                <!-- <p>test</p> -->
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div style="position:relative">
        <v-premium-plan-popup></v-premium-plan-popup>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xs-12">
              <h3 class="title">Unanswered Questions</h3>
            </div>
            <br>
            <br>
            <div class="container-fluid">
              <div
                style="background: white;border-radius: 10px; border: 1px solid #eee;padding: 15px;margin-top: 10px;"
              >
                <div class="row">
                  <div class="col-sm-12">
                    <span class="dashboard_datepicker">From:
                      <datepicker
                        v-model="selectedDate.start"
                        style="margin-bottom: 10px;"
                      ></datepicker>
                    </span>
                    <span class="hidden-xs" style="margin: 0 10px">-</span>
                    <span class="dashboard_datepicker" style="margin-bottom: 10px;">To:
                      <datepicker v-model="selectedDate.end" ></datepicker>
                    </span>
                    <span class="hidden-xs" style="margin-right: 10px;"></span>
                    <div class="hidden-sm hidden-md hidden-lg"></div>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-sm"
                      :class="{'btn-primary': currentFilter == 'today' , 'btn-default' : currentFilter != 'today' }"
                      style="margin-bottom: 5px;"
                    >Today</a>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-sm"
                      :class="{'btn-primary': currentFilter == 'this_month' , 'btn-default' : currentFilter != 'this_month' }"
                      style="margin-bottom: 5px;"
                    >This Month</a>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-sm"
                      :class="{'btn-primary': currentFilter == 'last_month' , 'btn-default' : currentFilter != 'last_month' }"
                      style="margin-bottom: 5px;"
                    >Last 30 Days</a>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-sm"
                      :class="{'btn-primary': currentFilter == 'this_year' , 'btn-default' : currentFilter != 'this_year' }"
                      style="margin-bottom: 5px;"
                    >This Year</a>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div class="col-sm-6">
              <input type="text" class="form-control" placeholder="Search">
            </div>
          </div>
          <div class="row">
            <hr>
          </div>
        </div>

        <div>
          <div class="container-fluid">
            <div style="background: #eee;padding: 15px;margin-bottom: 15px;">
              <div class="row" style=" ">
                <div class="col-sm-5">
                  <input type="checkbox" disabled>  Select All
                </div>
                <div class="col-sm-7" style=" text-align: right">
                  <a
                    href="javascript:void(0)"
                    class="btn btn-primary transparent btn-sm"
                  >Ignore Selected</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid" >
          <div class="row" style="padding: 15px;">
            <div class="col-xs-12" style="margin-bottom: 10px;">
              <div class="row" style="border: 1px solid #eee; padding: 15px; border-left: 3px solid #eee">
                <div style="margin-bottom: 5px">
                  <div class="col-sm-7" style>
                    <input type="checkbox" readonly disabled>
                    <div
                      style="height: 15px;position: relative;top: 3px;display: inline-block; width: 100%; max-width: 100px;background-color: #eee"
                    ></div>
                  </div>
                  <div class="col-sm-5" style="text-align: right">
                    <template>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm transparent"
                        style="margin-bottom: 2px;margin-top: 2px;"
                      >Ignore</a>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm transparent"
                        style="margin-bottom: 2px;margin-top: 2px;"
                      >Create new</a>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm transparent"
                        style="margin-bottom: 2px;margin-top: 2px;"
                      >Add existing</a>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12" style="margin-bottom: 10px;">
              <div class="row" style="border: 1px solid #eee; padding: 15px; border-left: 3px solid #eee">
                <div style="margin-bottom: 5px">
                  <div class="col-sm-7" style>
                    <input type="checkbox" readonly disabled>
                    <div
                      style="height: 15px;position: relative;top: 3px;display: inline-block; width: 100%; max-width: 100px;background-color: #eee"
                    ></div>
                  </div>
                  <div class="col-sm-5" style="text-align: right">
                    <template>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm transparent"
                        style="margin-bottom: 2px;margin-top: 2px;"
                      >Ignore</a>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm transparent"
                        style="margin-bottom: 2px;margin-top: 2px;"
                      >Create new</a>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm transparent"
                        style="margin-bottom: 2px;margin-top: 2px;"
                      >Add existing</a>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12" style="margin-bottom: 10px;">
              <div class="row" style="border: 1px solid #eee; padding: 15px; border-left: 3px solid #eee">
                <div style="margin-bottom: 5px">
                  <div class="col-sm-7" style>
                    <input type="checkbox" readonly disabled>
                    <div
                      style="height: 15px;position: relative;top: 3px;display: inline-block; width: 100%; max-width: 100px;background-color: #eee"
                    ></div>
                  </div>
                  <div class="col-sm-5" style="text-align: right">
                    <template>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm transparent"
                        style="margin-bottom: 2px;margin-top: 2px;"
                      >Ignore</a>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm transparent"
                        style="margin-bottom: 2px;margin-top: 2px;"
                      >Create new</a>
                      <a
                        href="javascript:void(0);"
                        class="btn btn-primary btn-sm transparent"
                        style="margin-bottom: 2px;margin-top: 2px;"
                      >Add existing</a>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
        </div>


      </div>
    </template>

    <modal-dialog v-if="showModal" @close="showModal = false">
      <span slot="header">Training</span>

      <div slot="body">
        <input type="text" class="form-control" placeholder="Search" v-model="searchIntent">

        <hr>

        <ul class="training-data" style="margin: 0;padding: 0">
          <li
            class="item"
            v-for="(intent, index) in filterIntents"
            :key="'intent_'+index"
            @click="addTrainingToConversation(intent)"
          >{{intent.intentname}}</li>
        </ul>
      </div>

      <div slot="footer">
        <a href="javascript:void(0);" class="btn btn-default" @click="showModal = false">Close</a>
      </div>
    </modal-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ModalDialog from "@/components/elements/ModalDialog";
import TrainingItem from "./TrainingItem";
import api from "@/api";
// import { clearInterval } from "timers";

import datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  data: function() {
    return {
      training_intents: [],
      intents: [],
      search: "",
      searchIntent: "",
      showModal: false,
      currentDefaultIntents: undefined,
      newIntent: {},
      allSelected: false,
      selectedDate: {
        start: moment()
            .startOf("month")
            .toDate(),
        end: moment()
            .endOf("month")
            .toDate()
      },
      currentFilter: "this_month",
      ignoreInterval: undefined,
      ignoreCount: 0
    };
  },
  components: {
    ModalDialog,
    TrainingItem,
    datepicker
  },
  mounted: function() {
    var vm = this;
    if (vm.$store.getters.getPackage != 'premium') {
      return false
    }
    if (vm.$route.query.datefrom) {
      vm.selectedDate.start = vm.$route.query.datefrom;
    }
    if (vm.$route.query.dateto) {
      vm.selectedDate.end = vm.$route.query.dateto;
    }

    vm.getIntent(function() {
      vm.getTrainingConversation();
    });
  },
  computed: {
    ...mapGetters({
      selectedBot: "selectedBot"
    }),
    excludedIntentName: function() {
      var result = [];
      var vm = this;
      $.each(vm.intents, function(index, intent) {
        result.push(intent.intentname);
      });
      return result.join(",");
    },
    filterDefaultIntents: function() {
      var vm = this;
      return vm.training_intents.filter(intent => {
        var isFound = false;
        if (intent.questiondata != null) {
          isFound =
            intent.questiondata
              .toLowerCase()
              .includes(vm.search.toLowerCase()) && intent.training != true;
        }
        return isFound;
      });
    },
    filterIntents: function() {
      var vm = this;
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase(); // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase(); // ignore upper and lowercase
        if (
          a.intentname[0] == "{" &&
          a.intentname[a.intentname.length - 1] == "}"
        ) {
          return 1;
        }
        if (
          b.intentname[0] == "{" &&
          b.intentname[b.intentname.length - 1] == "}"
        ) {
          return -1;
        }
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });

      return vm.intents.filter(intent => {
        var isFound = intent.intentname
          .toLowerCase()
          .includes(vm.searchIntent.toLowerCase());
        //  ||
        // intent.q_val.toLowerCase().includes(vm.searchIntent.toLowerCase()) ||
        // intent.a_val.toLowerCase().includes(vm.searchIntent.toLowerCase())
        return isFound;
      });
    }
  },
  methods: {
    onSelectedStartDate: function(value) {
      var vm = this;
      vm.currentFilter = "";
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value;
      }
      this.selectedDate.start = value;
      this.getTrainingConversation();
    },
    onSelectedEndDate: function(value) {
      var vm = this;
      vm.currentFilter = "";
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value;
      }
      this.selectedDate.end = value;
      this.getTrainingConversation();
    },
    onSelectedDate: function(value) {
      this.getTrainingConversation();
    },
    changeDate: function(value) {
      var vm = this;
      vm.currentFilter = value;
      switch (value) {
        case "today":
          vm.selectedDate.start = moment().toDate();
          vm.selectedDate.end = moment().toDate();
          break;

        case "last_month":
          vm.selectedDate.start = moment()
            .subtract(1, "months")
            .toDate();
          vm.selectedDate.end = moment().toDate();
          break;

        case "this_month":
          vm.selectedDate.start = moment()
            .startOf("month")
            .toDate();
          vm.selectedDate.end = moment()
            .endOf("month")
            .toDate();
          break;

        case "this_year":
          vm.selectedDate.start = moment()
            .startOf("year")
            .toDate();
          vm.selectedDate.end = moment()
            .endOf("year")
            .toDate();
          break;
      }
      vm.onSelectedDate();
    },
    getTrainingConversation: function() {
      var vm = this;
      var data = {
        pageid: vm.selectedBot.pageid,
        intentname: "default",
        datefrom: moment(this.selectedDate.start).format("YYYY-MM-DD"),
        dateto: moment(this.selectedDate.end).format("YYYY-MM-DD")
      };
      vm.$store.dispatch("loading");
      api.getTraningConversation(data, function(error, response) {
        if (error) {
          console.error(error);
          vm.$store.dispatch("loading");
          return;
        }
        var training_intents = [];
        $.each(response.data, function(index, intent) {
          var tmp_intent = intent;
          tmp_intent.selected = false;

          var isFound = false;

          $.each(training_intents, function(index, value) {
            if (value.id != tmp_intent.id &&
              tmp_intent.questiondata == value.questiondata ) {
              training_intents[index].count += 1
            }

            if (
              value.id != tmp_intent.id &&
              tmp_intent.questiondata == value.questiondata &&
              tmp_intent.training != true &&
              value.training != true
            ) {
              isFound = true;
              // vm.updateTrainingConversation(value.id, function(index) {});
              return false;
            }

          });

          if (!isFound) {
            tmp_intent.count = 1
            training_intents.push(tmp_intent);
          }
        });

        vm.training_intents = training_intents

        vm.$store.dispatch("loading");
      });
    },
    getIntent: function(callback) {
      let vm = this;
      let auth = null;
      let data = {
        pageid: vm.selectedBot.pageid
      };
      vm.intents = []
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error);
          return;
        }
        if (response.data) {
          var isFoundDefault = false;
          $.each(response.data, function(index, val) {
            var intent = val;
            intent.isShow = false;
            intent.ableToDelete = true;
            if (intent.intentname == "default") {
              intent.ableToDelete = false;
              isFoundDefault = true;
              vm.default_intent = intent;
            } else {
              vm.intents.push(intent);
            }
          });
        }
        callback();
      });
    },
    addTrainingToConversation: function(intent) {
      let vm = this;

      let data = {
        pageid: vm.selectedBot.pageid,
        intentname: intent.intentname,
        q_type: intent.q_type,
        q_val: intent.q_val + "," + vm.currentDefaultIntents.questiondata,
        a_type: intent.a_type,
        a_val: intent.a_val,
        context_in: intent.context_in,
        context_out: intent.context_out,
        quick_reply: intent.quick_reply
      };

      if (data.a_type == "message" || data.a_type == "generic") {
        data.a_val = "{welcome_message}";
      } else if (data.a_type == "template") {
        data.a_val = JSON.stringify(vm.generics);
      } else if (data.a_type == "viewsummary") {
        data.a_val = "{viewsummary}";
      } else if (data.a_type == "none") {
        data.a_val = "";
      }

      if (vm.isReplyComment) {
        data.a_val = vm.replyComment;
      }

      if (
        confirm(
          'Do you want to add "' +
            vm.currentDefaultIntents.questiondata +
            '" to "' +
            intent.intentname +
            '"'
        )
      ) {
        vm.$store.dispatch("loading");
        data["id"] = intent.id;
        api.editIntent(data, function(error, response) {
          if (error) {
            console.error(error);
            vm.$store.dispatch("loading");
            return;
          }

          var data = {
            pageid: vm.selectedBot.pageid,
            questiondata: vm.currentDefaultIntents.questiondata,
            newintent: intent.intentname
          }
          vm.updateTrainingConversation(data, function(
            index
          ) {
            if (index) {
              vm.$set(vm.training_intents[index], "training", true);
            }
            vm.$store.dispatch("loading");
          });
          vm.showModal = false;
        });
      }
    },
    updateTrainingConversation: function(data, callback) {
      var vm = this;
      api.updateTrainingConversation(data, function(error, response) {
        if (error) {
          console.error(error);
          callback();
          return;
        }
        if (vm.training_intents.length <= 0) {
          callback(null);
          return false;
        }
        $.each(vm.training_intents, function(index, intent) {
          if (intent.questiondata == data.questiondata) {
            callback(index);
            return false;
          }
        });
      });
    },
    saveTrainingIntent: function(payload) {
      var vm = this;
      vm.$store.dispatch("loading");
      var data = {
        pageid: vm.selectedBot.pageid,
        questiondata: payload.questiondata,
        newintent: payload.intentname
      }
      vm.updateTrainingConversation(data, function(index) {
        vm.getIntent(function(){
          if (index) {
            vm.$set(vm.training_intents[index], "training", true);
          }
          vm.$store.dispatch("loading");
        })
      });
    },
    ignoreAll: function() {
      var vm = this;
      vm.$store.dispatch("loading");
      vm.ignoreCount = vm.training_intents.length;

      $.each(vm.training_intents, function(index, intent) {
        if (intent.selected) {
          vm.ignoreTrainingIntent(intent.id, function() {
            vm.ignoreCount--;
          });
        } else {
          vm.ignoreCount--;
        }
      });
      vm.ignoreInterval = setInterval(() => {
        if (vm.ignoreCount == 0) {
          clearInterval(vm.ignoreInterval);
          vm.$store.dispatch("loading");
        }
      }, 100);
    },
    onIgnore: function(id) {
      var vm = this;
      vm.$store.dispatch("loading");
      vm.ignoreTrainingIntent(id, function() {
        vm.$store.dispatch("loading");
      });
    },
    ignoreTrainingIntent: function(questiondata, callback) {
      var vm = this;
      // vm.$store.dispatch("loading");
      var data = {
        pageid: vm.selectedBot.pageid,
        questiondata: questiondata,
        newintent: ''
      }
      vm.updateTrainingConversation(data, function(index) {
        if (index) {
          vm.$set(vm.training_intents[index], "training", true);
        }

        callback();
      });
    },
    selectAll: function() {
      var vm = this;
      vm.intentId = [];
      $.each(vm.filterDefaultIntents, function(index, intent) {
        $.each(vm.training_intents, function(dindex, dintent) {
          if (intent.id == dintent.id) {
            vm.training_intents[dindex].selected = vm.allSelected;
            return false;
          }
        });
      });
    },
    select: function() {
      this.allSelected = false;
    }
  },
  watch: {
    allSelected: function(newVal, oldVal) {
      var vm = this;
      vm.selectAll();
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/intent/Training.vue